
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { supabase } from "@/integrations/supabase/client";
import AdminHeader from '@/components/admin/AdminHeader';
import UserManagement from '@/components/admin/UserManagement';
import RewardCampaigns from '@/components/admin/RewardCampaigns';
import AdminAnalytics from '@/components/admin/AdminAnalytics';
import SweepstakesManagement from '@/components/admin/sweepstakes/SweepstakesManagement';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTranslation } from 'react-i18next';
import { useAppSettings } from '@/hooks/useAppSettings';
import { useAdminStatus } from '@/hooks/useAdminStatus';

const AdminDashboard = () => {
  const { t } = useTranslation(['admin', 'common']);
  const [activeTab, setActiveTab] = useState('users');
  const targetEmail = 'info@jeremygabon.com';
  const { logoUrl } = useAppSettings();
  
  // We don't need isAdmin or loading states anymore because AdminProtectedRoute handles that
  const handleTabChange = (value: string) => {
    setActiveTab(value);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F8F7F5] to-[#F5EBD8]/30">
      <AdminHeader />
      
      <main className="container mx-auto py-8 px-4">
        <h1 className="text-3xl font-bold mb-6">{t('admin:dashboard')}</h1>
        
        <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full">
          <TabsList className="mb-6">
            <TabsTrigger value="users">{t('admin:users')}</TabsTrigger>
            <TabsTrigger value="campaigns">{t('admin:campaigns')}</TabsTrigger>
            <TabsTrigger value="sweepstakes">{t('admin:sweepstakes')}</TabsTrigger>
            <TabsTrigger value="analytics">{t('admin:analytics')}</TabsTrigger>
          </TabsList>
          
          <TabsContent value="users" className="space-y-4">
            <UserManagement />
          </TabsContent>
          
          <TabsContent value="campaigns" className="space-y-4">
            <RewardCampaigns />
          </TabsContent>
          
          <TabsContent value="sweepstakes" className="space-y-4">
            <SweepstakesManagement />
          </TabsContent>
          
          <TabsContent value="analytics" className="space-y-4">
            <AdminAnalytics />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};

export default AdminDashboard;
